var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-chip',{staticClass:"bottom-center saving",attrs:{"label":"","color":"yellow lighten-4"}},[_vm._v(_vm._s(_vm.title)+" "),_c('span',[_vm._v(".")]),_c('span',[_vm._v(".")]),_c('span',[_vm._v(".")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8953162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/widgets/ThreeDots.vue
// module id = 314
// module chunks = 4